import React, {Component} from 'react'
import {Grid, Row, Col} from "react-bootstrap";
import {Card} from "components/Card/Card.jsx";
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';
import {createOrderActions} from "../../../redux/actions/create-order-actions";
import {Link} from "react-router-dom";
import ThemeModal from '../../ThemeComponents/ThemeModal';

import BrandLogo from "./BrandLogo";
import ViewCartProductsList from './ViewCartProductsList';
import OrderProducts from './OrderProducts';
import $ from "jquery";
import {confirmAlert} from "react-confirm-alert";
import Confirmalertfordelete from "../../ThemeComponents/confirmAlertForDelete";

var cloneDeep = require('lodash.clonedeep');

class ViewCart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            selectedBrand: null,
            selectedTaglayout: null,
            productAttributes: null,
            orderAttributes: null,
            exportAttributes: null,
            filterAttributes: null,
            cart: null,
            cartProductspageSize: 10,
            productsData: [],
            selectedFilterAttributes: [],
            selectAddAll: false,
            expire_cart: false,
            brands: [],
        }

        this.child = React.createRef();
    }

    refreshCartProducts = () => {
        this.props.getCartProductsCall({
            cart: this.state.cart,
            brand: this.state.selectedBrand,
            filterTerm: this.state.filtered,
            productAttributes: this.state.productAttributes,
            page: 1,
            sort: '',
            pageSize: this.state.cartProductspageSize,
        }).then(response => {
            this.setState({
                ...this.state,
                productsData: this.props.productsData,
            });
        });
    }

    resetLookupState = () => {
        this.setState({
            selectedFilterAttributes: [],
            selectAddAll: false
        });
    };

    toggleCheckAllState = (state) => {
        this.setState({
            selectAddAll: state
        });
    }

    componentDidMount = () => {
        if (this.props.match.params.cart_id) {
            this.props.getCartCall(this.props.match.params.cart_id).then(response => {
                const brand = response.cart.brand_detail || {};
                brand.logo_path = response.cart.logo_path;
                brand.brand_id = brand.id;
                this.setState({
                    selectedBrand: brand,
                    selectedTaglayout: response.cart.tag_layout_attributes,
                    cart: response.cart.cart,
                    productAttributes: response.cart.product_attributes,
                    exportAttributes: response.cart.exportAttributes,
                    orderAttributes: response.cart.order_attributes,
                    selectedFilterAttributes: response.cart.selected_filters,
                    filterAttributes: response.cart.filter_attributes,
                });

                this.props.getAllBrandsCall(1, "", "", 10).then(
                    response => {
                        let fetched_brands = response.result.brands;
                        if (fetched_brands.length > 0) {
                            fetched_brands.forEach(item => {
                                if (item.brand_id === brand.id) {
                                    this.setState({
                                        selectedBrand: item
                                    })
                                }
                            })
                        }
                    },
                    error => {
                        return error;
                    }
                );
            });
        }
    }

    productsPaginationData = (page, filter, sort, pageSize) => {
        this.setState({cartProductspageSize: pageSize}, function () {
            this.props.getCartProductsCall({
                cart: this.state.cart,
                brand: this.state.selectedBrand,
                filterTerm: this.state.filtered,
                productAttributes: this.state.productAttributes,
                page,
                sort,
                pageSize,
            }).then(response => {
                this.setState({
                    ...this.state,
                    productsData: this.props.productsData,
                });
            });
        });
    };

    deleteProductFromCart = (data) => {
        return this.props.deleteProductFromCartCall({
            product_ids: data,
            brand: this.state.selectedBrand
        }).then(response => {
            this.props.getCartProductsCall({
                cart: this.state.cart,
                brand: this.state.selectedBrand,
                filterTerm: this.state.filtered,
                productAttributes: this.state.productAttributes,
                page: 1,
                sort: '',
                pageSize: this.state.cartProductspageSize
            }).then(response => {
                this.setState({
                    ...this.state,
                    productsData: this.props.productsData
                });
            });
        });
    }

    changeHandler = (e, id, index) => {
        e.preventDefault();
        const name = e.target.name;
        let productsData = cloneDeep(this.state.productsData);
        let item = {...productsData[index]};
        item[name] = e.target.value;
        productsData[index] = item;
        this.setState({productsData}, function () {
            setTimeout(() => {
                this.child.current.doFocus ? this.child.current.doFocus("#" + name + "-" + index) : null;
            }, 200);
        });
    };

    saveCart = () => {
        let pids = [];
        let selected_pids = [];
        let chosen_atts = {};

        pids = this.state.productsData.map(p => p.id);

        let validation_failed = false;
        pids.forEach((prdId, idx) => {
            const product = this.state.productsData.find(
                item => item.id === prdId
            );
            this.state.orderAttributes.forEach(obj => {
                if (obj.adjust_product_attribute !== null) {
                    if (product[obj.adjust_product_attribute_name] < parseInt(product[obj.db_column]) && !this.state.productsData[idx].tag_layout.allow_quantity_increase) {
                        validation_failed = true;
                    }

                    if (parseInt(product[obj.db_column]) > 0) {
                        selected_pids = [...selected_pids, prdId];
                        // chosen_atts = [...chosen_atts, this.state.productsData[idx]];
                        chosen_atts [prdId] = this.state.productsData[idx];

                    }
                } else {
                    if (parseInt(product[obj.db_column]) > 0) {
                        selected_pids = [...selected_pids, prdId];
                        chosen_atts [prdId] = this.state.productsData[idx];

                        // chosen_atts = [...chosen_atts, this.state.productsData[idx]];
                    }
                }
            });
        });
        if (validation_failed) {
            $("#checkall").prop("checked", false);
            confirmAlert({
                customUI: ({onClose}) => {
                    return (
                        <Confirmalertfordelete msgType="warning" onClosePro={onClose} header="Validation Error!"
                                               description="Order quantity cannot be more than available quantity!"/>
                    )
                }
            })
            return;
        }

        //
        this.props.saveCartCall({
            brand: this.state.selectedBrand,
            orderAttributes: this.state.orderAttributes,
            productsData: this.state.productsData
        });
    }

    addToCartView = () => {
        this.props.history.push({
            pathname: '/Admin/create-order',
            state: {selectedBrand: this.state.selectedBrand}
        })
        return;
    }

    getLookupState = state => {
        if (state.selectValue !== undefined) {
            this.setState(prevState => ({
                selectedFilterAttributes: [
                    ...prevState.selectedFilterAttributes.filter(
                        item => item.attribute_id !== state.selectValue.attribute_id
                    )
                ]
            }), () => {
                this.setState(prevState => ({
                    selectedFilterAttributes: [
                        ...prevState.selectedFilterAttributes,
                        state.selectValue
                    ]
                }));
            });
        }
    };

    render() {
        return (
            <React.Fragment>
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                ctTableResponsive
                                content={
                                    <div>
                                        {this.state.cart != null &&
                                        <React.Fragment>
                                            <div className="row">
                                                <h3
                                                    style={{
                                                        textAlign: "center",
                                                        fontWeight: "500"
                                                    }}
                                                >
                                                    View Cart
                                                </h3>
                                            </div>
                                            <div className="clearfix"></div>
                                            <div className="flexElem respFlex spaceBetween respFlex">
                                                <div>
                                                    <div className="brandInfo flexElem respFlex alignCenter">
                                                        <BrandLogo brand={this.state.selectedBrand}
                                                                   customClasses="ml-md text_16"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mt-xlg">
                                                <ViewCartProductsList
                                                    productsData={this.state.productsData}
                                                    productAttributesProp={this.state.productAttributes}
                                                    orderAttributesProp={this.state.orderAttributes}
                                                    exportAttributes={this.state.exportAttributes}
                                                    cart={this.state.cart}
                                                    selectedBrand={this.state.selectedBrand}
                                                    productsPaginationData={this.productsPaginationData}
                                                    pageSize={this.state.cartProductspageSize}
                                                    filtered={this.state.filtered}
                                                    pages={this.props.products_pages}
                                                    loading={this.props.loading}
                                                    deleteProductFromCart={this.deleteProductFromCart}
                                                    changeHandler={this.changeHandler}
                                                    ref={this.child}
                                                />
                                            </div>
                                            <div className="mt-lg text-center">
                                                <button type="button" onClick={() => this.addToCartView()}
                                                        className="customBtn btnBlack m-md btn-lg">
                                                    Add Items
                                                </button>
                                                <button type="button" className="customBtn btnBlue m-md btn-lg"
                                                        onClick={this.saveCart}>
                                                    Save
                                                </button>
                                                {this.state.cart &&
                                                <Link to={`/Admin/cart/${this.state.cart.id}/checkout`}>
                                                    <button type="button" className="customBtn btnBlue m-md btn-lg">
                                                        Check Out
                                                    </button>
                                                </Link>}
                                            </div>
                                        </React.Fragment>
                                        }
                                    </div>}/>
                        </Col></Row></Grid>


                <ThemeModal title="Add Products to Cart" hide={() => {
                    this.setState({showModal: !this.state.showModal})
                }} show={this.state.showModal} size="full">
                    <div className="mt-xlg">
                        <OrderProducts
                            getLookupState={this.getLookupState}
                            selectedBrand={this.state.selectedBrand}
                            selectedTag={this.state.selectedTaglayout}
                            filterAttributes={this.state.filterAttributes}
                            selectedFilterAttributes={
                                this.state.selectedFilterAttributes
                            }
                            selectedTaglayout={this.state.selectedTaglayout}
                            prevStepNum={this.state.nextStepNum}
                            productAttributes={this.state.productAttributes}
                            orderAttributes={this.state.orderAttributes}
                            currentStep="4"
                            showListOnly="true"
                            selectAddAll={this.state.selectAddAll}
                            returnState={this.toggleCheckAllState}
                            cart={this.state.cart}
                            refreshCartProducts={this.refreshCartProducts}
                        />
                    </div>
                </ThemeModal>
            </React.Fragment>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return ({
        getAllBrandsCall: () => {
            return dispatch(
                createOrderActions.getCustomerBrandsList()
            );
        },
        getCartCall: (id) => {
            return dispatch(
                createOrderActions.getCart(id)
            );
        },
        getCartProductsCall: (data) => {
            return dispatch(
                createOrderActions.getCartProductsPagination(data)
            )
        },
        deleteProductFromCartCall: (data) => {
            return dispatch(createOrderActions.deleteProductFromCart(data))
        },
        saveCartCall: (data) => {
            dispatch(createOrderActions.saveCart(data))
        },
    });
};

function mapStateToProps(state) {
    const {
        productsData,
        products_pages,
        products_current_page
    } = state.createOrdersReducer;

    return {
        productsData,
        products_pages,
        products_current_page
    };
}

const OrderDetail = connect(mapStateToProps, mapDispatchToProps)(ViewCart);
export default withRouter(OrderDetail);



// WEBPACK FOOTER //
// ./src/components/Admin/Order/ViewCart.jsx